import { useEffect, useState } from 'react';
import api from '../services/api';

/**
 * Live team (squad) names from the server.
 *
 * Teams come from server/src/config/squads.json via GET /api/analytics/squads
 * and must never be hardcoded in the client: a duplicated client-side list is
 * exactly what left the dashboard showing stale project groups
 * (Reliability/Security/IT/Service) after the real teams were defined.
 *
 * Shared by every filter surface so they cannot drift from each other.
 */
export default function useTeamOptions(enabled = true) {
  const [teamOptions, setTeamOptions] = useState([]);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;

    api
      .get('/analytics/squads')
      .then(({ data }) => {
        if (cancelled) return;
        const names = (data.squads || [])
          .filter((item) => !item.placeholder)
          .map((item) => item.name);
        setTeamOptions(names);
      })
      .catch(() => {
        // An empty list degrades to "All teams" rather than breaking the page.
        if (!cancelled) setTeamOptions([]);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return teamOptions;
}
